/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { string, bool, func } from 'prop-types';
import classNames from 'clsx';

import BlackTieIcon from 'components/BlackTieIcon/BlackTieIcon';

import styles from './system-message.scss';

/**
 * This is the SystemMessage component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class SystemMessage extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    message: string.isRequired,
    offsetTop: bool,
    error: bool,
    success: bool,
    info: bool,
    onClick: func,
  };

  static defaultProps = {
    offsetTop: false,
    error: false,
    success: false,
    info: false,
    onClick: () => {},
  };

  /**
   * Render SystemMessage.
   *
   * @return {Object}
   */
  render() {
    const { message, offsetTop, error, success, info, onClick } = this.props;

    const icon = error
      ? 'times-circle'
      : success
      ? 'check-circle'
      : 'info-circle';

    return (
      <div
        className={classNames(styles.wrapper, {
          [styles.offsetTop]: offsetTop,
        })}
      >
        <div className={styles.message}>
          <BlackTieIcon
            icon={icon}
            className={classNames(styles.icon, {
              [styles.error]: error,
              [styles.success]: success,
              [styles.info]: info,
            })}
          />

          <p className={styles.text}>{message}</p>
        </div>
        <button type="button" className={styles.button} onClick={onClick}>
          <BlackTieIcon icon="times-circle" className={styles.buttonIcon} />
        </button>
      </div>
    );
  }
}

export default SystemMessage;
